<template>
  <mapit-dialog :dialog="dialogOpen" @close="onCancel">
    <template v-slot:header-icon>
      <v-icon color="orange">fa-solid fa-warning</v-icon>
    </template>

    <template v-slot:header-text>
      <p class="text-center" v-html="dialog.title"></p>
    </template>

    <template v-slot:body>
      <div class="text-center">
        <div v-html="dialog.content"></div>
      </div>
    </template>

    <template v-slot:footer-center>
      <v-btn @click="onCancel" class="btn-gray">{{ dialog.cancel }}</v-btn>
      <v-btn @click="onUpdate" class="btn-primary">{{ dialog.confirm }}</v-btn>
    </template>
  </mapit-dialog>
</template>

<script lang="ts">
import {defineComponent, ref, watch} from '@vue/composition-api'

import MapitDialog from '@/components/dialog/MapitDialog.vue'
import {mapGetters} from '@/utils/map-store'
import {setAppVersionToStore} from '@/utils/versions'

export default defineComponent({
  name: 'DialogVersion',
  components: {MapitDialog},
  setup(props, {root}) {
    const dialogOpen = ref(false)
    const {getAppVersion: appVersion} = mapGetters(root.$store.getters)

    const dialog = {
      title: root.$t('reload.title'),
      content: root.$t('reload.content'),
      cancel: root.$t('reload.cancel'),
      confirm: root.$t('reload.confirm'),
    }

    function onCancel() {
      setAppVersionToStore(appVersion.value, 60 * 24)
      root.$store.dispatch('setAppVersion') // reset version of the state
      dialogOpen.value = false
    }

    function onUpdate() {
      setAppVersionToStore(appVersion.value, 60 * 24)
      location.reload()
    }

    watch(appVersion, newVersion => {
      if (newVersion) {
        dialogOpen.value = true
      }
    })

    return {
      dialog,
      dialogOpen,
      onCancel,
      onUpdate,
    }
  },
})
</script>
